import { hotTopics } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function Hot() {
  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="container-x">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="Hot Focus"
            title="本月焦点速览"
            desc="先看一眼这个月最值得吃的大瓜，每一条背后都有完整经过。点进去即可展开对应时间线，理清前因后果。"
          />
          <a
            href="#timeline"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
          >
            进入完整时间线 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-4 md:mt-10 md:grid-cols-2 md:gap-5">
          {hotTopics.map((t) => (
            <article
              key={t.id}
              className="group relative overflow-hidden rounded-xl bg-background-100 p-5 ring-1 ring-background-200 transition-colors hover:ring-primary-300 md:p-6"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                  <i className="ri-price-tag-3-line"></i> {t.category}
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-eye-line"></i> {t.views} 浏览
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                {t.title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-foreground-600">{t.summary}</p>
              <a
                href="#timeline"
                className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
              >
                回顾完整经过
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}